const system = {
    state: {
        scale_ratio:1,//1300显示区域自适应比例
        scale_mob:false,
        system_data: {
            logo:null,
            address:'',
            brandManager:'',
            phone:'',
            email:'',
            socialMediaUrl:'',
            socialMedia:'',
            beian:'备案号：京ICP备13032638号-1'
        },//系统信息
        prev_page: null//上级页面
    },

    mutations: {
        set_scale_ratio: (state, data) => {
            state.scale_ratio = data;
        },
        set_scale_mob: (state, data) => {
            state.scale_mob = data;
        },
        set_system_data: (state, data) => {
            state.system_data = data;
        },
        set_prev_page: (state, data) => {
            state.prev_page = data;
        }
    },
    actions: {}
};

export default system;
